
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"36","height":"36","viewBox":"20 9 36 36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M37.603 17l-.147.501v14.547l.147.147 6.735-3.991L37.603 17z","fill":"#343434"}}),_c('path',{attrs:{"d":"M37.602 17l-6.735 11.204 6.735 3.991V17z","fill":"#8C8C8C"}}),_c('path',{attrs:{"d":"M37.603 33.474l-.083.102v5.181l.083.243 6.74-9.515-6.74 3.99z","fill":"#3C3C3B"}}),_c('path',{attrs:{"d":"M37.602 39v-5.526l-6.735-3.99L37.602 39z","fill":"#8C8C8C"}}),_c('path',{attrs:{"d":"M37.606 32.195l6.735-3.991-6.735-3.07v7.06z","fill":"#141414"}}),_c('path',{attrs:{"d":"M30.867 28.204l6.735 3.99v-7.06l-6.735 3.07z","fill":"#393939"}})])
          )
        }
      }
    